module.exports = __webpack_public_path__ + "static/media/skl.35252651.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/skl.png
// module id = 479
// module chunks = 0